module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "chapter06"
    }
  }), _vm._v("CHAPTER SIX")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Wednesday, February 17")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("9:45 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex was still asking herself those same questions as she called good night to her colleagues two days later. She exited the bar. Business had been slow, so she had clocked out a few minutes early. Located in the Mission district, Third Place was usually hopping weeknights until ten o’clock, when activity slowed considerably. Tonight had been a crawl; her feet and back ached from standing around doing nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It’d given her too much time to think, as well. About her mother. Her illness and her secrets. And to worry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As she neared her car, she saw Tim leaning against it, waiting for her. He always looked every inch the hip professor, from his shaggy threaded-with-silver blond hair to his Armani sweater and Ecco driving mocs.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Typical Tim. She had left him a message after leaving her mother’s the other afternoon; instead of a call back, here he was at bedtime, tail wagging and puppy dog earnest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She couldn’t help but smile. Knowing exactly where she stood with him took the angst out of their relationship. For her, anyway. It also placed her in the driver’s seat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Hey,” she said as she neared him. “I thought you might have decided I was more trouble than I’m worth.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Never.” He kissed her cheek. Another woman’s perfume, flowery and sweet, clung to him. “How was work?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("“Slow.” She tucked her hair behind her ear. “One of those nights I had too much time to think.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“What’s going on? You sounded pretty upset when you called.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I needed someone to talk to.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Your mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“How’d you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Recognized your tone.” He leaned forward, lowered his voice to the silky rumble she used to love. “What happened to us, Alex?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Where did "), _c('em', [_vm._v("that")]), _vm._v(" come from?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I miss you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She placed her hand against his chest to keep him from moving closer. “Even if we forget that you couldn’t keep your peter in your pants, we have nothing in common.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Not true. We’re both seekers. Both fascinated by the universal quest for meaning. What people will do to find it.” He grinned. “And we were great together in bed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Not so great the other night.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You were having head issues.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She winced at the way he casually tossed that out there. As if her “head issues” were a common occurrence, in the sack and otherwise. It struck a nerve—she lived in fear she had inherited her mother’s mental illness, although at thirty it still hadn’t manifested itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Was her “vision” the other night its first appearance?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I know what you’re thinking,” he said softly. He covered her hand with his. “I didn’t mean anything by that. You’re not like her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She searched his gaze. Should she tell him about her vision? Get his opinion, see if he could help her figure it out?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She opened her mouth to do that, but instead said, “The day I called, I’d stopped by to see her. She’s not taking her meds and was in the middle of a manic episode.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’m sorry, Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Me, too. It’s so frustrating.” She heard helplessness in her voice and fought it. “Thanks for listening.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You want to have a drink? My shoulder’s available.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex was tempted, but suspected what that drink would lead to. And even though she knew she wouldn’t find what she sought through sex, she wasn’t "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("that strong right now. “I don’t think so, Tim. I’m back to work on my dissertation and keeping some late hours. I’m pretty tired.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I could wake you up,” he teased. “Plus, I’d like a chance to expunge my record.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She unlocked her car. “Sorry. Not happening.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“You know I still love you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Still not happening.” She kissed him lightly on the mouth, slid into her vehicle, and drove away. When she reached the corner, Alex glanced in the rearview mirror and found he had already gone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Probably into the bar in the hopes of convincing some other woman to give him the chance to prove himself, she thought. So much for love.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The light ahead turned red, and Alex eased to a stop. She dug her cell phone out of her purse and flipped it open. She had missed several calls and had a new message waiting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("All from her mother. The first had come in at 1:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M")]), _vm._v("., not that long after she had arrived at work. She’d left the voice mail a couple hours ago.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex punched in her password and her mother’s voice came through the device.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I have to talk to you, Alex. I have to—” She sounded horrible. Voice slurry, thick. With tears? Or from self-medication? Alex didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“I’ll tell you everything. I promise . . . I—” Her mother drew in a shuddering breath. “I didn’t mean for any of this to happen—I only wanted, I—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The message clicked off. Had she hung up? Alex wondered, a catch in her chest. Or had the machine cut her off?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Either way, what had happened was obvious. The pendulum had swung back—mania had become depression.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At the blare of a horn behind her, Alex rolled through the intersection. She had to check on her, make certain she was all right.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sighing, Alex turned onto Guerrero Street heading toward her mother’s house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ten minutes later she braked in front of her mother’s. The house was dark, not a sliver of light spilled from any of the windows. She climbed out of her car and hurried up the walk.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She let herself in. “Mother,” she called. “It’s Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Only silence answered and she flipped on the light. Carnage greeted her. Her mother’s beautiful canvases all destroyed. Some obliterated by paint, "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("others scraped clean and a few slashed, as if in one final burst of despair or fury.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It hurt to look at them and she averted her gaze. The shades were all drawn tight and Alex wondered if she had even opened them to the day. It had rained earlier and she saw a puddle of water on the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“Mom,” she called again, heading up the curving stairs. “It’s Alex.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She reached the second-floor landing and started for the master bedroom. She would find her in bed. Maybe sleeping. Maybe curled up under the covers, staring at nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The glow from a streetlight fell across her mother’s bed. She wasn’t wrong, Alex saw. Her mother was there, lying on her back, blanket a jumble around her, as if she had been thrashing about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex crossed to her. “Mom,” she said softly, “are you awake?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She didn’t reply and Alex bent to straighten the blankets. Her hand knocked something to the floor. A pill vial, she realized, bending to retrieve it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Seroquel. It was empty.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Her heart jumped to her throat. “Mom,” she said, loudly this time. “Mom!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Alex shook her. Her body was stiff. Her skin cold to the touch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She shook her again, panicking. “No, no, no . . . you did not do this . . . Mom, talk to me. Wake up!” She caught her mother’s hand, frantically pressed her fingers to the wrist, praying for even a flutter of a pulse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Nothing. Nothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With a cry, she stumbled backward, fumbling for her phone. She found it, but dropped her purse, the contents spilling across the floor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("She punched in 911. “Hello? Oh my God . . . I think my mother . . . I can’t get a pulse! I think she’s . . . please, you’ve got to help!”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fc805e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter06.vue
// module id = 99
// module chunks = 0